import { TabsLayout } from "@jugl-web/ui-components";
import { useAppVariant, useTranslations } from "@jugl-web/utils";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import React from "react";
import {
  ManageAccountsDrawerScreenToParametersMap,
  ManageAccountsDrawerTab,
} from "../../types";

export const CRMDrawerTabsLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslations();
  const { isCx } = useAppVariant();
  const { screen, transitionTo } =
    useScreenTransitionManager<ManageAccountsDrawerScreenToParametersMap>();

  return (
    <TabsLayout
      selectedTab={
        screen.name === "aiAgentInsights"
          ? ManageAccountsDrawerTab.aiAgentInsights
          : ManageAccountsDrawerTab.channels
      }
      tabs={[
        {
          id: ManageAccountsDrawerTab.channels,
          title: t({
            id: "client-support-page.channels",
            defaultMessage: "Channels",
          }),
          onClick: () => transitionTo({ name: "connectedAccountList" }),
        },
        {
          id: ManageAccountsDrawerTab.aiAgentInsights,
          title: t({
            id: "client-support-page.ai-agent-insights",
            defaultMessage: "AI Agent Insights",
          }),
          onClick: () => transitionTo({ name: "aiAgentInsights" }),
          hidden: isCx,
        },
      ]}
    >
      {children}
    </TabsLayout>
  );
};
